<div class="col-md-12">
    <div class="row">
        <div class="col d-flex align-items-center">
            <img class="image-icon-sm" src="content/images/review-crosses.png">
            <h4 class="ms-1 pt-1">
                <span jhiTranslate="design-crosses.preview.crosses">Preview Crosses</span>&nbsp;
            </h4>
        </div>
    </div>
    <div class="row" style="padding-left: 10px;">
        <div class="col-6 d-flex align-items-center justify-content-start">
                        <span jhiTranslate="global.total.entries" [translateValues]="{param: totalItems}"></span>
            @if (crosses.length > 0) {
                <jhi-selection-count [showSelectAll]="true"
                                     [isSelectAll]="isSelectAll"
                                     [totalItemsSize]="totalItems"
                                     [selectedItemsSize]="selectedItems.size"
                                     (deselectAction)="clearSelectedItems()"
                                     (selectAllAction)="selectAll($event)"></jhi-selection-count>
            }
        </div>
        <div class="col-6 d-flex align-items-center justify-content-end">
            <div ngbDropdown class="d-inline-block ps-2" placement="bottom-right">
                <button  class="btn btn-info btn-sm" id="columnsDropdown" ngbDropdownToggle>
                    <span translate="study-editor.actions"></span>
                </button>
                <div ngbDropdownMenu aria-labelledby="columnsDropdown">
                    <button ngbDropdownItem type="submit"
                            (click)="removeSelected()">
                        <span jhiTranslate="design-crosses.actions.remove.selected"></span>
                    </button>
                    <button ngbDropdownItem type="submit"
                            (click)="clearAll()">
                        <span jhiTranslate="design-crosses.actions.clear.all"></span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row pt-3">
        <div class="col">
            <div class="d-flex align-items-center">
                <span class="me-2" jhiTranslate="global.records.per.page">Records per page:</span>
                <select class="form-select form-select-sm" style="width: auto;"
                        (change)="onPageSizeChange($event)">
                    @for (option of pageSizeOptions; track option) {
                        <option [value]="option" [selected]="pageSize === option">{{ option }}</option>
                    }
                </select>
            </div>
        </div>
    </div>
    <div class="table-responsive col-md-12 pt-2">
        <div class="custom-scroll-style" style="max-height: 400px; overflow: auto">
            <table class="table table-striped table-curved table-bordered">
                <thead class="sticky-header">
                <tr jhiSort [(predicate)]="predicate" [(ascending)]="reverse" [callback]="sort.bind(this)">
                    <th style="width: 30px"><input type="checkbox" class="form-check-input" [ngbTooltip]="'global.select.current.page' | translate" [checked]="isPageSelected()" (click)="onSelectPage()"></th>
                    <th style="width: 30px" [jhiSortBy]="ColumnHeaders.ENTRY_NO"><span>#</span> <span class="fa fa-sort"></span></th>
                    <th style="width: 100px;"><span jhiTranslate="design-crosses.preview.table.female.parent">FEMALE PARENT</span></th>
                    <th style="width: 100px;"><span jhiTranslate="design-crosses.preview.table.male.parent">MALE PARENT</span></th>
                    <th style="width: 100px;" [jhiSortBy]="ColumnHeaders.FEMALE_CROSS"><span jhiTranslate="design-crosses.preview.table.female.cross">FEMALE CROSS</span> <span class="fa fa-sort"></span></th>
                    <th style="width: 100px;" [jhiSortBy]="ColumnHeaders.MALE_CROSS"><span jhiTranslate="design-crosses.preview.table.male.cross">MALE CROSS</span> <span class="fa fa-sort"></span></th>
                    <th style="width: 100px;" [jhiSortBy]="ColumnHeaders.GERMPLASM_ORIGIN"><span jhiTranslate="design-crosses.preview.table.germplasm.origin">GERMPLASM_ORIGIN</span> <span class="fa fa-sort"></span></th>
                </tr>
                </thead>
                <tbody *ngIf="crosses.length">
                <tr *ngFor="let cross of pagedData; trackBy: trackId; index as index"
                    (click)="toggleSelect($event, index, cross); $event.stopPropagation()"
                    [class.selected]="isSelected(cross)"
                    (mousedown)="$event.preventDefault()"
                    #p="ngbPopover"
                    (contextmenu)="showRightClickMenu($event, p)"
                    [autoClose]="true"
                    [triggers]="'manual'"
                    [ngbPopover]="cellContextMenu">
                    <td style="width: 30px;"><input type="checkbox" class="form-check-input" [checked]="isSelected(cross)" (click)="toggleSelect($event, index, cross, true); $event.stopPropagation()"></td>
                    <td style="width: 30px;">{{cross.entryNumber}}</td>
                    <td style="width: 100px;">
                        <span *ngIf="!cross.femaleParents || cross.femaleParents.length === 0"> - </span>
                        <span *ngIf="cross.femaleParents">
                            <jhi-expandable-cell [data]="getNames(cross.femaleParents)" [asLink]="true" (itemClick)="germplasmDetailsPopupService.open(cross.femaleParents[$event].gid)"></jhi-expandable-cell>
                        </span>
                    </td>
                    <td style="width: 100px;">
                        <span *ngIf="!cross.maleParents || cross.maleParents.length === 0"> - </span>
                        <span *ngIf="cross.maleParents">
                            <jhi-expandable-cell [data]="getNames(cross.maleParents)" [asLink]="true" (itemClick)="germplasmDetailsPopupService.open(cross.maleParents[$event].gid)"></jhi-expandable-cell>
                        </span>
                    </td>
                    <td style="width: 100px;"><truncate-span [textInput]="cross.femalePedigreeString" [maxLength]="100"></truncate-span></td>
                    <td style="width: 100px;"><truncate-span [textInput]="cross.malePedigreeString" [maxLength]="100"></truncate-span></td>
                    <td style="width: 100px;"><truncate-span [textInput]="cross.seedSource" [maxLength]="100"></truncate-span></td>
                </tr>
                </tbody>
            </table>
        </div>
        <!-- Pagination controls -->
        <div class="d-flex justify-content-between align-items-center mt-3">
            <div>
				<span jhiTranslate="study-editor.pagination.entry-count"
					  [translateValues]="{param1: (currentPage - 1) * pageSize + 1, param2: Math.min(currentPage * pageSize, totalItems), param3: totalItems}"></span>
            </div>
            <ngb-pagination
                    [collectionSize]="totalItems"
                    [(page)]="currentPage"
                    [pageSize]="pageSize"
                    [maxSize]="5"
                    [rotate]="true"
                    [boundaryLinks]="true"
                    (pageChange)="onPageChange($event)">
            </ngb-pagination>
        </div>
    </div>
</div>

<ng-template #cellContextMenu>
    <div class="p-2">
        <button class="btn btn-sm btn-outline-info w-100" type="submit" (click)="removeSelected()" jhiTranslate="design-crosses.actions.delete.selected">
        </button>
        <button class="btn btn-sm mt-2 btn-outline-info w-100" type="submit" (click)="clearAll()" jhiTranslate="design-crosses.actions.clear.all">
        </button>
    </div>
</ng-template>
